





















































import { Component, Vue } from 'vue-property-decorator';

import axios from 'axios';
import FileSaver from 'file-saver';

@Component
export default class UserImportView extends Vue {
  private file: File | null = null;
  private uploading: boolean = false;

  private downloadExampleCSVFile(): void {
    const csv: string =
      'firstName,middleName,lastName,title,phone,email,userGroups\n' +
      'John,,Smith,Developer,(555) 555-5555,johnsmith@thecompany.com,Development\n' +
      'Jane,,Doe,Graphic Designer,(555) 555-5555,janedoe@thecompany.com,"Marketing,Product Design"\n';
    const blob: Blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
    FileSaver.saveAs(blob, 'example.csv');
  }

  private async uploadFile(): Promise<void> {
    this.uploading = true;
    const url: string = `${process.env.VUE_APP_BACKEND_API_HOST}/new_users/import`;
    const data = new FormData();
    data.append('file', this.file!);
    const accessToken: string = await (this as any).$auth0.getAccessTokenSilently();
    axios.post(url, data, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }).then((response) => {
      const message: string = 'Successfully imported users and groups';
      this.$bvModal.msgBoxOk(message, {
        title: 'Import Successful',
        okVariant: 'success',
        centered: true,
      }).then(() => {
        this.$router.push({ name: 'users' });
      });
    }).catch((error) => {
      const message: string = error.response?.data?.message ?? error.message;
      this.$bvModal.msgBoxOk(message, {
        title: 'Error Importing Users',
        okVariant: 'danger',
        centered: true,
      });
    }).finally(() => {
      this.uploading = false;
    });
  }
}
